var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('back-to-top'),_c('main-content'),_c('stage-intro'),_c('function-service'),_c('advantage'),_c('partner'),_c('footer-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }